<template>
  <div>
    <div class="white-header csmz-header">
      <el-row class="container">
        <el-col :sm="0" :xs="2">
             <NavMenu class="mobile"   :config="config"
          :menus="menus"
          :menuClass="menuClass"/>
        </el-col>
        <el-col :sm="20" :xs="20">
          <el-image
            class="logo"
            fit="contain"
            :src="require('@/assets/images/kcsz/header-logo.png')"
            @click="goPortal()"
          ></el-image>
        </el-col>
        <el-col class="align-right" :sm="4" :xs="2">
          <Login />
        </el-col>
      </el-row>
    </div>
    <el-image
      class="banner pc"
      fit="cover"
      :src="require('@/assets/images/kcsz/banner.jpg')"
    ></el-image>
    <el-image
      class="banner mobile"
      fit="cover"
      :src="require('@/assets/images/kcsz/banner.png')"
    ></el-image>
  </div>
</template>

<script>
import Login from "./Login.vue";
import NavMenu from "@/components/NavMenu.vue";
export default {
  name: "Header",
  props:{
  config:Object,
  menus:Array,
  menuClass:String
  },
  components: {
    Login,
    NavMenu
  }
};
</script>

<style lang="scss" scoped>
.white-header {
  position: absolute;
  z-index: 10;
  top: 20px;
  left: 0;
  width: 100%;
  overflow: hidden;
}

.logo {
  visibility: hidden;
  vertical-align: middle;
}

.align-right {
  text-align: right;
}

.banner {
  display: block;
  height: 170px;
}

@media (max-width: 767px) {
  .white-header {
    position: relative;
    top: 0;
    z-index: unset;
    height: 51px;
    line-height: 50px;
    background-color: #fff;
    text-align: center;
    border-bottom: 1px solid #e5e5e5;
  }

  .logo {
    margin: auto;
    max-width: 96%;
    line-height: 20px;
    visibility: visible;
    display: inline-block;
    height: 30px;
  }

  .banner {
    height: 50px;
  }
}
#app .csmz-header {
  /deep/.el-button--danger {
    background-color: #ffffff;
    border: 1px solid #ffffff;
    border-radius: 2px;
    font-size: 12px;
    color: #ff4300;
    &:hover, &:focus {
      background-color: #ef5839;
      border-color: #ef5839;
      color: #fff;
    }
  }
  .login .name{
    color: #ffffff;
  }
}
</style>

